module.exports = __webpack_public_path__ + "static/media/NextStepClock.11b3ea8a.svg";